import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';
import { getDocumentListData } from '@/utils/document';

export const documentListRoute: RouteConfig = {
  path: '',
  name: 'documentList',
  component: () => import(/* webpackChunkName: "DocumentList" */ '@/views/mainRoute/procedure/details/DocumentTab.vue'),
  beforeEnter: (to, from, next) =>
    getDocumentListData(to)
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.DOCUMENT_CANNOT_LIST }))
};
